<template>
  <v-img
    v-if="props.purpose.imageUrl"
    :src="props.purpose.imageUrl"
    height="260"
    cover
  />
  <v-img v-else src="/public-portal/images/SailingPOV.jpg" height="260" cover />
  <v-card-title class="px-6 pt-5 text-h5">{{ props.name }}</v-card-title>
  <v-card-text class="px-6 pb-6 text-body-1">
    {{ props.purpose.portalDescription }}
  </v-card-text>
</template>
<script lang="ts" setup>
import type { DonationPurpose } from "@/composables/donations/useDonationNew";
const props = defineProps<{
  purpose: DonationPurpose;
  name: string;
}>();
</script>
